import baseErrorReport from '@didi/error-base'
import OmegaTracker from '@didi/omega-tracker-lite'
import errorCodeConfig from '../config/errorcodeConfig.json'

// 稳定性平台标识符号（唯一）,前往稳定性平台获取
const APPID = '46-116-140'

export const errorReport = () => baseErrorReport(
  /**
  * OmegaTracker（omega通过CDN引入的情况，可以直接传入window.Omega）
  */
  OmegaTracker, 
  /**
  * 应用ID（稳定性平台标识符号）
  */
  APPID, 
  /**
  * 自定义配置
  */
  {
    /**
    * 是否捕获打印错误（可选）
    */
    consoleError: false,
    /**
    * 错误码配置
    */
    errorCodeConfig: errorCodeConfig,
  }
)